module.exports = __webpack_public_path__ + "static/media/subscriptions_blue.6d24e5a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/subscriptions_blue.svg
// module id = ./src/assets/media/forum/subscriptions_blue.svg
// module chunks = 16